var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 904.602,
    height: 542.557,
    viewBox: "0 0 904.602 542.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241",
    transform: "translate(-9786 3566.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6303",
    "data-name": "Path 6303",
    d: "M0,0S131.6,49.721,293.146,15.435,463.393-95.3,646.2-137.147s258.4,0,258.4,0v236.1s-99.591-39.253-217.854,0c-111.386,36.97-238.457,152.02-348.366,169.887C112.23,305.6,0,246,0,246Z",
    transform: "translate(9786 -3410.997)",
    fill: "#7fd030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6302",
    "data-name": "Path 6302",
    d: "M0,0S131.6,49.721,293.146,15.435,463.393-95.3,646.2-137.147s258.4,0,258.4,0v236.1s-99.591-39.253-217.854,0c-111.386,36.97-238.457,152.02-348.366,169.887C112.23,305.6,0,246,0,246Z",
    transform: "translate(9786 -3304.997)",
    fill: "#009822"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWave);
export default __webpack_public_path__ + "static/media/green_wave.6f42c4200765d81345c91c97f1a0c25f.svg";
export { ForwardRef as ReactComponent };